import script from "./item.vue?vue&type=script&setup=true&lang=ts"
export * from "./item.vue?vue&type=script&setup=true&lang=ts"

import "./item.vue?vue&type=style&index=0&id=c1a0bd28&lang=less&scoped=true"

import exportComponent from "/Users/nikkizeng/Desktop/running/ph-miao-wechat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1a0bd28"]])

export default __exports__